import { format, isBefore, subDays, subHours } from 'date-fns';
import { useCallback, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import MyModal from '../../../../../components/Modal';
import { ReactCalendarCustomStyle } from '../../../../../components/ReactCalendarCustomStyle';
import useThemeContext from '../../../../../contexts/theme';
import { Value } from '../../types';
import { Group } from './styles';

interface ISearchByPeriodModal {
  searchByPeriodModalShow: boolean;
  setSearchByPeriodModalShow: React.Dispatch<React.SetStateAction<boolean>>;
  searchByPeriod: (period: Value) => void;
}

export default function SearchByPeriodModal({
  searchByPeriodModalShow,
  setSearchByPeriodModalShow,
  searchByPeriod
}: ISearchByPeriodModal) {
  const [specificPeriod, setSpecificPeriod] = useState<Value>([new Date(), new Date()]);
  const [specificPeriodLabel, setSpecificPeriodLabel] = useState(`De ${format(new Date(), 'dd/MM/yyyy')} até ${format(new Date(), 'dd/MM/yyyy')}`);

  const handleSpecificPeriodChange = useCallback(async (value: Value) => {
    if (Array.isArray(value)) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const adjustedByTimezone = value.map((date) => subHours(date!, 3));

      const minDateAllowed = subDays(adjustedByTimezone[1], 31);

      if (isBefore(adjustedByTimezone[0], minDateAllowed)) {
        toast.warn('Período selecionado ultrapassa o limite de 1 mês');
        return;
      }

      setSpecificPeriod([adjustedByTimezone[0], adjustedByTimezone[1]]);

      const periodLabel = `De ${format(value[0] as Date, 'dd/MM/yyyy')} até ${format(value[1] as Date, 'dd/MM/yyyy')}`;
      setSpecificPeriodLabel(periodLabel);
    } else {
      toast.error('Erro ao selecionar período');
    }
  }, []);

  const { selectedTheme } = useThemeContext();

  return (
    <MyModal
      show={searchByPeriodModalShow}
      title={'Pesquisar por Período'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByPeriodModalShow(false)}
      onAction={() => searchByPeriod(specificPeriod)}
      type="action"
      size='lg'
      centeredBody
      modalBody={(
        <Group>
          {selectedTheme === 'dark' ? (
            <ReactCalendarCustomStyle>
              <Calendar
                onChange={handleSpecificPeriodChange}
                value={specificPeriod}
                selectRange maxDate={new Date()}
              />
            </ReactCalendarCustomStyle>
          ) : (
            <Calendar
              onChange={handleSpecificPeriodChange}
              value={specificPeriod}
              selectRange
              maxDate={new Date()}
            />
          )}
          <small>
                  Período {specificPeriodLabel}
          </small>
        </Group>
      )}
    />
  );
}
